module.exports = __webpack_public_path__ + "static/img/20017 (2).bd0f947.webp";


//////////////////
// WEBPACK FOOTER
// ./src/assets/20000/20017 (2).webp
// module id = q+Kn
// module chunks = 14